<div class="loader-div">
    <div class="panel-body tabbed-panel">
        <div class="col-12">
            <div class="row">
                <div class="col-md-5">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-3 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 ps-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-3 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 ps-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-3 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 ps-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-3 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 ps-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-3 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 px-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
                <div class="col-md-2 ps-4">
                    <div class="txt-loading txt-sm mb-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>